import { Flex, styled } from "front-commons/ds";

export const HeaderPromotionDetails = styled(Flex)`
	border-bottom: 1px solid var(--surface-primary);
`;
